import { render, staticRenderFns } from "./EditableTableWithFile.vue?vue&type=template&id=52b4dc32&"
import script from "./EditableTableWithFile.vue?vue&type=script&lang=js&"
export * from "./EditableTableWithFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports